import axios from 'axios';
import { property } from 'lodash';

import { generateApiError } from './utils/apiErrorMessages';
import { buildApiV2Url, jsonApiHeaders } from './utils/apiUtils';
import { mapSurveyImageFromApiModel } from './dataMapper/surveyImage';

const getImage = imageId =>
  axios
    .get(
      buildApiV2Url(`images/${imageId}`, {
        include: 'entities',
      }),
      {
        headers: jsonApiHeaders,
      },
    )
    .catch(generateApiError())
    .then(property('data.data'))
    .then(mapSurveyImageFromApiModel);

export default getImage;
